import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsComponent } from '../events/events.component';
import { UserManagementComponent } from '../user-management/user-management.component';
import { LoginPageComponent } from '../login-page/login-page.component';
import { SidebarComponent } from '../../core/sidebar/sidebar.component';
import { getCurrentUser } from 'aws-amplify/auth';

@Component({
  selector: 'app-redirect',
  standalone: true,
  imports: [
    CommonModule,
    EventsComponent,
    UserManagementComponent,
    LoginPageComponent,
    SidebarComponent
  ],
  template: `
    <ng-container *ngIf="user; else loginTemplate">
      <div *ngIf="canViewEvents">
        <app-events></app-events>
      </div>

      <div *ngIf="!canViewEvents">
        <app-user-management></app-user-management>
      </div>
    </ng-container>
    <ng-template #loginTemplate>
      <app-login-page></app-login-page>
    </ng-template>
  `
})
export class RedirectComponent implements OnInit {
  user: string | null;
  canViewEvents: boolean = false;

  async ngOnInit() {
    try{
      this.user = (await getCurrentUser()).username;
    } catch {}

    const roles = (localStorage.getItem('ACCOUNT_ROLES') || '').split(',');

    this.canViewEvents = roles.includes('EOD_PERSONNEL') || roles.includes('FRONT_LINE_REPORTER');
  }
}
